import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import AboutPreview from "@/components/home/AboutPreview";
import ServicesPreview from "@/components/home/ServicesPreview";
import TrustSignals from "@/components/home/TrustSignals";
import ServiceAreas from "@/components/home/ServiceAreas";
import ContactPreview from "@/components/home/ContactPreview";
import { Seo } from "@/lib/seo";
import { Helmet } from "react-helmet-async";


const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Lawnworks Of NWA",
    "description": "Professional landscape and irrigation design & installation services in Bella Vista, Rogers, Bentonville, Fayetteville and surrounding NWA areas.",
    "telephone": "+1-479-464-9398",
    
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hindsville",
      "addressRegion": "AR",
      "postalCode": "72738",
      "addressCountry": "US"
    },
    "url": "https://www.lawnworksnwa.com",
    "openingHours": "Mo-Fr 08:00-17:00",
    "areaServed": ["Bella Vista", "Rogers", "Bentonville", "Fayetteville", "Northwest Arkansas"],
    "priceRange": "$$"
  };

  return (
    <Layout>
      <Seo
        title="Lawnworks Of NWA | Landscape & Irrigation Services"
        description="Landscape design, irrigation, drainage and seasonal color in Bella Vista, Rogers, Bentonville and NWA. Family-owned, 25+ years. Free estimates."
        path="/"
        keywords="landscaping, irrigation, landscape design, drainage services, seasonal color, Bella Vista, Rogers, Bentonville, Fayetteville, NWA, Arkansas"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <HeroSection />
      <AboutPreview />
      <ServicesPreview />
      <TrustSignals />
      
      <ServiceAreas />
      <ContactPreview />
    </Layout>
  );
};

export default Index;
